export class CostReviewGeneralConditions {
  isGeneralConditionsApplicableLessThanThreshold!: boolean;
  isGeneralConditionsApplicable!: boolean;
  minority!: number;
  prevailingWage!: number;
  tradeAgreementAct!: number;
  buyAmerica!: number;
  buyAmericanAct!: number;
  bimModeling!: number;
  schedulerEstimate!: number;
  travelExpensesPlanned!: number;
  overtimeEstimated!: string;
  escalationIncluded!: string;
  trailerRentalSpace!: number;
  utilitiesCosts!: number;
  officeSuppliesCosts!: number;
  liftCosts!: number;
  bim360FieldConfiguration!: number;
  salesTax!: number;
  sparePartsPercent!: number;
  equipmentEnclosures!: number;
  deviceAccessPanels!: number;
  fieldProcurementManager!: number;
  temporarySitePersonnel!: number[];
  serviceContract!: number;
  projectIsPhased!: number | null;
  ifYesDescribe!: string;
  parkingFees!: number;
  taxRequired!: number;
  sparePointCapacity!: number;
  cpmHoursEstimated!: number;
}
